// @ts-nocheck
import isApiError from "@insite/client-framework/Common/isApiError";
import { API_URL_CURRENT_FRAGMENT, post, ServiceResult } from "@insite/client-framework/Services/ApiService";
import { AddProductApiParameter } from "@insite/client-framework/Services/CartService";
import { CartLineModel } from "@insite/client-framework/Types/ApiModels";

const cartsUrl = "/api/v1/carts";

export async function addProductWithResult(parameter: AddProductApiParameter): Promise<ServiceResult<CartLineModel>> {
    const cartLine = {
        productId: parameter.productId,
        qtyOrdered: parameter.qtyOrdered,
        unitOfMeasure: parameter.unitOfMeasure,
        notes: parameter.notes,
        sectionOptions: parameter.sectionOptions,
    } as CartLineModel;

    if (parameter.subscription) {
        cartLine.properties = {
            productSubscription: JSON.stringify(parameter.subscription),
        };
    }

    /* Store Custom Code - Start */
    if (parameter.embroideries) {
        cartLine.properties = {
            ...cartLine.properties,
            embroideries: JSON.stringify(parameter.embroideries),
        };
    }
    /* Store Custom Code - End */

    try {
        const cartLineModel = await post(`${cartsUrl}/${API_URL_CURRENT_FRAGMENT}/cartlines`, cartLine);
        return {
            successful: true,
            result: cartLineModel,
        };
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        if (error.status === 403) {
            return {
                successful: false,
                errorMessage: error.errorMessage,
                statusCode: 403,
            };
        }
        throw error;
    }
}
